function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const { getDataFromComeet } = require("../comeet-service/comeet-service");
const { getAshbyPositions, normalizeAshbyPosition } = require("../ashby-service/ashby-service");
const { mergeAndDeduplicate } = require("../deduplicate-positions-service/deduplicate-positions");
const { InternalServerError } = require("../../extensions/error-extensions");
const { logError, logInfo } = require("../../logging/logger");
const { JOB_SOURCE_COMEET } = require("../../../components/pages/careers/careers-constants");
const validateAndNormalizeComeetData = (data)=>{
    if (!data || data.ERROR) {
        logError("Comeet positions data is invalid or empty", {
            hasData: !!data,
            error: data === null || data === void 0 ? void 0 : data.ERROR
        });
        throw new InternalServerError("error fetching positions data");
    }
    return data.map((position)=>_object_spread_props(_object_spread({}, position), {
            source: JOB_SOURCE_COMEET
        }));
};
const fetchAllPositions = function() {
    var _ref = _async_to_generator(function*(req) {
        const [comeetResult, ashbyResult] = yield Promise.all([
            getDataFromComeet().then((data)=>({
                    success: true,
                    data
                }), (e)=>{
                logError("Failed to fetch positions from Comeet", {
                    error: e === null || e === void 0 ? void 0 : e.message
                });
                return {
                    success: false,
                    data: null
                };
            }),
            getAshbyPositions(req).then((data)=>({
                    success: true,
                    data
                }), (e)=>{
                logError("Failed to fetch positions from Ashby", {
                    error: e === null || e === void 0 ? void 0 : e.message
                });
                return {
                    success: false,
                    data: null
                };
            })
        ]);
        if (!comeetResult.success || !comeetResult.data) {
            throw new InternalServerError("error fetching positions data");
        }
        const comeetPositions = validateAndNormalizeComeetData(comeetResult.data);
        if (!ashbyResult.success || !ashbyResult.data || ashbyResult.data.ERROR) {
            var _ashbyResult_data;
            if ((_ashbyResult_data = ashbyResult.data) === null || _ashbyResult_data === void 0 ? void 0 : _ashbyResult_data.ERROR) {
                logError("Ashby positions data contains errors", {
                    error: ashbyResult.data.ERROR
                });
            }
            return comeetPositions;
        }
        const ashbyPositions = ashbyResult.data.map(normalizeAshbyPosition);
        logInfo("Fetched positions from both sources", {
            comeet: comeetPositions.length,
            ashby: ashbyPositions.length
        });
        return mergeAndDeduplicate(comeetPositions, ashbyPositions);
    });
    return function fetchAllPositions(req) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    fetchAllPositions
};
